import React, { Component } from 'react'
import NumberFormat from 'react-number-format'
import InputMask from 'react-input-mask'
import { Icon, Tooltip } from 'antd'
import { withFormsy } from 'formsy-react'
import { cnpj as CNPJ } from 'cpf-cnpj-validator'

import {
  toFullCurrency,
  integerTransform,
  floatTransform,
  newIntegerTransform,
} from '../../utils/numberFormatters'

import css from './index.scss'

const formatFloatNumber = (value) => {
  let num = value
  if (!num) {
    return null
  }
  if (typeof num !== 'string') {
    num = String(num)
  }
  return parseFloat(num.replace(/[^0-9\\]+/g, '')) / 100
}

class CustomInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      number: '',
      formattedNumber: '',
    }
  }
  dismissSubmit = (e) => {
    e.preventDefault()
  }

  renderInput = () => {
    const newProps = { ...this.props }
    delete newProps.getErrorMessage
    delete newProps.getErrorMessages
    delete newProps.getValue
    delete newProps.hasValue
    delete newProps.isFormDisabled
    delete newProps.isValid
    delete newProps.isPristine
    delete newProps.isFormSubmitted
    delete newProps.isRequired
    delete newProps.isValidValue
    delete newProps.resetValue
    delete newProps.setValidations
    delete newProps.setValue
    delete newProps.showRequired
    delete newProps.showError
    delete newProps.gray
    delete newProps.validations
    delete newProps.validationError
    delete newProps.innerRef
    delete newProps.validationErrors
    delete newProps.textArea
    delete newProps.formStyle
    delete newProps.onPriceChange
    delete newProps.inputStyle
    delete newProps.onCepChange
    delete newProps.onCpfCnpjChange
    delete newProps.renderChildren
    delete newProps.infoLabel
    delete newProps.errorClassName

    if (this.props.mask) {
      switch (this.props.mask) {
        case 'plate': {
          return (
            <InputMask
              {...newProps}
              value={this.props.value}
              className={this.props.gray ? css.customInputGray : css.customInput}
              style={{
                ...this.props.inputStyle,
                paddingRight: this.props.rightLabel ? 33 : 0,
                textTransform: 'uppercase',
              }}
              onChange={(event) => {
                if (this.props.onChange) {
                  this.props.onChange(event)
                }
              }}
              placeholder={this.props.placeholder || 'ABC-1234'}
              mask="aaa-****"
              maskChar=""
            />
          )
        }
        case 'price': {
          return (
            <input
              {...newProps}
              name={this.props.name ? this.props.name : 'default'}
              type="text"
              className={this.props.gray ? css.customInputGray : css.customInput}
              placeholder={this.props.placeholder || 'R$ 0,00'}
              style={{ ...this.props.inputStyle, paddingRight: this.props.rightLabel ? 33 : 0 }}
              onChange={(e) =>
                this.props.onPriceChange(
                  toFullCurrency(e.target.value),
                  formatFloatNumber(e.target.value)
                )
              }
              disabled={this.props.disabled}
              value={toFullCurrency(this.props.value) || ''}
              required={this.props.required}
            />
          )
        }
        case 'integer': {
          return (
            <input
              {...newProps}
              name={this.props.name ? this.props.name : 'default'}
              type="text"
              className={this.props.gray ? css.customInputGray : css.customInput}
              placeholder={this.props.placeholder}
              style={{ ...this.props.inputStyle, paddingRight: this.props.rightLabel ? 33 : 0 }}
              onChange={(e) => this.props.onChange(integerTransform(e.target.value))}
              disabled={this.props.disabled}
              value={integerTransform(this.props.value) || ''}
              required={this.props.required}
            />
          )
        }
        case 'newInteger': {
          return (
            <input
              {...newProps}
              name={this.props.name ? this.props.name : 'default'}
              type="text"
              className={this.props.gray ? css.customInputGray : css.customInput}
              placeholder={this.props.placeholder}
              style={{ ...this.props.inputStyle, paddingRight: this.props.rightLabel ? 33 : 0 }}
              onChange={(e) => this.props.onChange(newIntegerTransform(e.target.value))}
              disabled={this.props.disabled}
              value={newIntegerTransform(this.props.value) || ''}
              required={this.props.required}
            />
          )
        }
        case 'float': {
          return (
            <input
              {...newProps}
              name={this.props.name ? this.props.name : 'default'}
              type="text"
              className={this.props.gray ? css.customInputGray : css.customInput}
              placeholder={this.props.placeholder}
              style={{ ...this.props.inputStyle, paddingRight: this.props.rightLabel ? 33 : 0 }}
              onChange={(e) =>
                this.props.onChange(
                  floatTransform(e.target.value),
                  formatFloatNumber(e.target.value)
                )
              }
              disabled={this.props.disabled}
              value={floatTransform(this.props.value) || ''}
              required={this.props.required}
            />
          )
        }
        case 'percentage': {
          return (
            <NumberFormat
              {...newProps}
              value={this.state.number}
              suffix={'%'}
              fixedDecimalScale
              className={this.props.gray ? css.customInputGray : css.customInput}
              style={{ ...this.props.inputStyle, paddingRight: this.props.rightLabel ? 33 : 0 }}
              decimalScale={0}
              onValueChange={(values) => {
                const { value, formattedValue } = values
                this.setState({ number: value, formattedValue })
                if (this.props.onPercentageChange) {
                  this.props.onPercentageChange(value)
                }
              }}
              disabled={this.props.disabled}
              renderText={() => `${this.state.formattedValue}`}
              placeholder="0%"
            />
          )
        }
        case 'ton': {
          return (
            <NumberFormat
              {...newProps}
              value={this.state.number}
              suffix={' ton'}
              fixedDecimalScale
              className={this.props.gray ? css.customInputGray : css.customInput}
              style={{ ...this.props.inputStyle, paddingRight: this.props.rightLabel ? 33 : 0 }}
              decimalScale={0}
              onValueChange={(values) => {
                const { value, formattedValue } = values
                this.setState({ number: value, formattedValue })
                if (this.props.onPercentageChange) {
                  this.props.onPercentageChange(value)
                }
              }}
              disabled={this.props.disabled}
              renderText={() => `${this.state.formattedValue}`}
              placeholder="0 ton"
            />
          )
        }
        case 'cep': {
          return (
            <NumberFormat
              {...newProps}
              value={this.props.value}
              className={this.props.gray ? css.customInputGray : css.customInput}
              style={{ ...this.props.inputStyle, paddingRight: this.props.rightLabel ? 33 : 0 }}
              onValueChange={(values) => {
                const { value } = values
                if (this.props.onCepChange) {
                  this.props.onCepChange(value)
                }
              }}
              disabled={this.props.disabled}
              placeholder="Ex.: 12345-789"
              format="#####-###"
              mask="_"
            />
          )
        }
        case 'cnpj': {
          return (
            <InputMask
              {...newProps}
              value={this.props.value}
              className={this.props.gray ? css.customInputGray : css.customInput}
              style={{ ...this.props.inputStyle, paddingRight: this.props.rightLabel ? 33 : 0 }}
              onChange={(event) => {
                if (this.props.onValueChange) {
                  const value = CNPJ.strip(event.target.value).slice(0, 14)
                  this.props.onValueChange(value)
                }
              }}
              placeholder={this.props.placeholder || 'Digite aqui o CNPJ'}
              mask="**.***.***/****-**"
              maskChar=""
            />
          )
        }
        case 'cpf': {
          return (
            <NumberFormat
              {...newProps}
              value={this.props.value}
              className={this.props.gray ? css.customInputGray : css.customInput}
              style={{ ...this.props.inputStyle, paddingRight: this.props.rightLabel ? 33 : 0 }}
              onValueChange={(values) => {
                const { value } = values
                if (this.props.onValueChange) {
                  this.props.onValueChange(value)
                }
              }}
              placeholder={this.props.placeholder || 'Ex.: 123.456.798-12'}
              format="###.###.###-##"
              mask=""
            />
          )
        }
        case 'phone': {
          return (
            <NumberFormat
              {...newProps}
              value={this.props.value}
              className={this.props.gray ? css.customInputGray : css.customInput}
              style={{ ...this.props.inputStyle, paddingRight: this.props.rightLabel ? 33 : 0 }}
              onValueChange={(values) => {
                const { value, formattedValue } = values
                if (this.props.onValueChange) {
                  this.props.onValueChange(value, formattedValue)
                }
              }}
              placeholder={this.props.placeholder || ''}
              format={(value) => {
                if (value && value.length <= 10) {
                  const ddd = value.substring(0, 2)
                  const phone1 = value.substring(2, 6)
                  const phone2 = value.substring(6)
                  if (phone2) {
                    return `(${ddd}) ${phone1}-${phone2}`
                  }
                  return `(${ddd}) ${phone1}`
                }
                const ddd = value.substring(0, 2)
                const phone1 = value.substring(2, 7)
                const phone2 = value.substring(7)
                return `(${ddd}) ${phone1}-${phone2}`
              }}
              mask=""
              maxLength={15}
            />
          )
        }
        case 'chassi': {
          return (
            <NumberFormat
              {...newProps}
              value={this.props.value}
              className={this.props.gray ? css.customInputGray : css.customInput}
              style={{ ...this.props.inputStyle, paddingRight: this.props.rightLabel ? 33 : 0 }}
              onValueChange={(values) => {
                const { value, formattedValue } = values
                if (this.props.onValueChange) {
                  this.props.onValueChange(value, formattedValue)
                }
              }}
              placeholder={this.props.placeholder || 'Digite seu chassi aqui'}
              format="#################"
              mask=""
            />
          )
        }
        case 'renavam': {
          return (
            <NumberFormat
              {...newProps}
              value={this.props.value}
              className={this.props.gray ? css.customInputGray : css.customInput}
              style={{ ...this.props.inputStyle, paddingRight: this.props.rightLabel ? 33 : 0 }}
              onValueChange={(values) => {
                const { value, formattedValue } = values
                if (this.props.onValueChange) {
                  this.props.onValueChange(value, formattedValue)
                }
              }}
              placeholder={this.props.placeholder || 'Digite seu renavam aqui'}
              format="###########"
              mask=""
            />
          )
        }
        case 'date': {
          return (
            <NumberFormat
              {...newProps}
              value={this.props.value}
              className={this.props.gray ? css.customInputGray : css.customInput}
              style={{ ...this.props.inputStyle, paddingRight: this.props.rightLabel ? 33 : 0 }}
              onValueChange={(values) => {
                const { value, formattedValue } = values
                if (this.props.onValueChange) {
                  this.props.onValueChange(value, formattedValue)
                }
              }}
              placeholder={this.props.placeholder || 'dd/mm/aaaa'}
              format="##/##/####"
              mask=""
            />
          )
        }
        default:
          return (
            <input
              {...newProps}
              name={this.props.name ? this.props.name : 'default'}
              type={this.props.type || 'text'}
              className={this.props.gray ? css.customInputGray : css.customInput}
              placeholder={this.props.placeholder}
              style={{ ...this.props.inputStyle, paddingRight: this.props.rightLabel ? 33 : 0 }}
              onChange={(e) => this.props.onChange(e)}
              disabled={this.props.disabled}
              value={this.props.value || ''}
              required={this.props.required}
            />
          )
      }
    }
    if (this.props.textArea) {
      return (
        <textarea
          {...newProps}
          name={this.props.name ? this.props.name : 'default'}
          type={this.props.type || 'text'}
          className={this.props.gray ? css.customInputGray : css.customInput}
          placeholder={this.props.placeholder}
          style={{ ...this.props.inputStyle, paddingRight: this.props.rightLabel ? 33 : 0 }}
          onChange={(e) => this.props.onChange(e)}
          rows={this.props.maxLines || 2}
          disabled={this.props.disabled}
          value={this.props.value}
          required={this.props.required}
        />
      )
    }
    return (
      <input
        {...newProps}
        name={this.props.name ? this.props.name : 'default'}
        type={this.props.type || 'text'}
        className={this.props.gray ? css.customInputGray : css.customInput}
        placeholder={this.props.placeholder}
        style={{ ...this.props.inputStyle, paddingRight: this.props.rightLabel ? 33 : 0 }}
        onChange={(e) => this.props.onChange(e)}
        disabled={this.props.disabled}
        value={this.props.value}
        required={this.props.required}
      />
    )
  }

  renderInfoLabel = () => {
    if (this.props.infoLabel) {
      return (
        <Tooltip title={this.props.infoLabel} placement="top">
          <span className={css.infoLabel}>
            <Icon type="info-circle" fill={this.props.gray ? '#686868' : '#340057'} />
          </span>
        </Tooltip>
      )
    }
    return null
  }

  renderLabel = () => {
    if (this.props.label) {
      return (
        <label className={this.props.gray ? css.inputLabelGray : css.inputLabel}>
          {this.props.label}
          {this.renderInfoLabel()}
        </label>
      )
    }
    return null
  }

  renderRightLabel = () => {
    if (this.props.rightLabel) {
      return <label className={css.rightLabel}>{this.props.rightLabel}</label>
    }
    return null
  }

  render() {
    const errorMessage = this.props.getErrorMessage()
    const errorMessages = this.props.getErrorMessages()
    return (
      <div style={this.props.style}>
        <div
          className={css.formContainer}
          onSubmit={this.dismissSubmit}
          style={this.props.formStyle}
        >
          {this.renderLabel()}
          {this.props.renderChildren ? (
            <span className={css.inputChild}>{this.props.renderChildren()}</span>
          ) : null}
          {this.renderInput()}
          <span
            className={[css.errorMessage, this.props.errorClassName].join(' ')}
            style={this.props.errorStyle}
          >
            {errorMessage || (errorMessages && errorMessages[0])}
          </span>
          {this.renderRightLabel()}
        </div>
      </div>
    )
  }
}

export default withFormsy(CustomInput)
